import { render, staticRenderFns } from "./myMaterial.vue?vue&type=template&id=d34f521c&scoped=true&"
import script from "./myMaterial.vue?vue&type=script&lang=js&"
export * from "./myMaterial.vue?vue&type=script&lang=js&"
import style0 from "./myMaterial.vue?vue&type=style&index=0&id=d34f521c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34f521c",
  null
  
)

export default component.exports